import { observer } from 'mobx-react-lite'
import React from 'react'
import classNames from 'classnames'
import { Typography } from 'shared/ui'
import { useReferralsViewContext } from 'pages/settings/pages/referrals/context/referralsViewContext'
import styles from './styles.module.scss'

export const ReferralsHistory = observer(() => {
  const { referralsInfo } = useReferralsViewContext()

  const historyCards = [
    {
      label: 'Clicks',
      count: referralsInfo?.leadsCount,
    },
    {
      label: 'Customers',
      count: referralsInfo?.visitorsCount,
    },
    {
      label: 'Earned',
      count: `$${referralsInfo?.earnings?.cash && referralsInfo.earnings.cash / 100}`,
    },
    {
      label: 'Paid',
      count: `$${referralsInfo?.paidBalance?.cash && referralsInfo.paidBalance.cash / 100}`,
    },
  ]

  return (
    <div className={classNames(styles.container)}>
      {historyCards.map((cardInfo) => (
        <div className={classNames(styles.content)} key={cardInfo.label}>
          <Typography
            variant='heading-md'
            color={'var(--content-primary-primary'}
            ariaLabel={`ReferralsHistory_${cardInfo.label}Value`}
            className={classNames(styles.count)}
          >
            {cardInfo.count}
          </Typography>
          <Typography
            variant='body-md-regular'
            color={'var(--content-primary-tertiary)'}
            ariaLabel='ReferralsHistory_clicks'
          >
            {cardInfo.label}
          </Typography>
        </div>
      ))}
    </div>
  )
})
